module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rp-modal-overlay"
  }, [_c('div', {
    staticClass: "rp-modal"
  }, [_c('div', {
    staticClass: "rp-modal-body pt0"
  }, [_c('h1', [_vm._v("Route Planner Vue v0.1")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Simple free tool for planning routes")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tThere's also small optional php+mysql backend for storing the data.\n\t\t\t")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "rp-welcome-buttons"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.openNewProject
    }
  }, [_vm._v("Create New Project")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.switchLoad
    }
  }, [_vm._v("Load Project")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.switchImport
    }
  }, [_vm._v("Import Project JSON")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.importOpened) ? _c('div', {
    staticClass: "nooverflow clearfix"
  }, [_c('div', {
    staticClass: "rp-import"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importText),
      expression: "importText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "20",
      "placeholder": "Paste JSON data here"
    },
    domProps: {
      "value": (_vm.importText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('Alert', {
    attrs: {
      "data": _vm.importAlert
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.importJson
    }
  }, [_vm._v("Import Project JSON")])])], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.loadOpened) ? _c('div', {
    staticClass: "nooverflow clearfix"
  }, [_c('div', {
    staticClass: "rp-load"
  }, [_c('Alert', {
    attrs: {
      "data": _vm.importAlert
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Project list")]), _vm._v(" "), (_vm.projects.length == 0) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Project Links not found in browser cache.")]) : _vm._e(), _vm._v(" "), (_vm.projects.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', _vm._l((_vm.projects), function(project) {
    return _c('tr', [_c('td', [(project.name) ? _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.$bus.$emit('loadProject', project)
        }
      }
    }, [_vm._v(_vm._s(project.name))])]) : _vm._e(), _vm._v(" "), (project.name) ? _c('div', [_vm._v("ID: " + _vm._s(project.id))]) : _c('div', [_vm._v("ID: "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.$bus.$emit('loadProject', project)
        }
      }
    }, [_vm._v(_vm._s(project.id))])]), _vm._v(" "), _c('div', [_vm._v("Private key: "), (project.privateId) ? _c('span', [_vm._v(_vm._s(project.privateId))]) : _c('span', [_vm._v("--viewonly--")])])]), _vm._v(" "), _c('td', [_c('div', [(project.privateId) ? _c('a', {
      attrs: {
        "href": '/#id=' + project.id + '&privateId=' + project.privateId,
        "target": "_blank"
      }
    }, [_vm._v("Edit link")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('a', {
      attrs: {
        "href": '/#id=' + project.id,
        "target": "_blank"
      }
    }, [_vm._v("View link")])])]), _vm._v(" "), _c('td', [_c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.removeFromLocalStorage(project)
        }
      }
    }, [_vm._v("Remove from browser cache")])]), _vm._v(" "), _c('div', [(project.privateId) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.deleteFromServer(project)
        }
      }
    }, [_vm._v("Delete from server")]) : _vm._e()])])])
  }))]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Add project")]), _vm._v(" "), _c('Alert', {
    attrs: {
      "data": _vm.newAlert
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newId),
      expression: "newId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Project ID"
    },
    domProps: {
      "value": (_vm.newId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPrivateId),
      expression: "newPrivateId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Private key"
    },
    domProps: {
      "value": (_vm.newPrivateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPrivateId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "form-control btn btn-default",
    attrs: {
      "disabled": _vm.newLoading
    },
    on: {
      "click": _vm.tryAddProject
    }
  }, [(_vm.newLoading) ? _c('span', {
    staticClass: "icon-loading icon-spin"
  }) : _c('span', [_vm._v("Add Project")])])])])])])], 1)]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This is the clone of my old original "), _c('a', {
    attrs: {
      "href": "https://github.com/Kasheftin/RoutePlanner"
    }
  }, [_vm._v("Route Planner")]), _vm._v(" that was written to deeply understand vue.js.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n\t\t\t\tIt uses "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/"
    }
  }, [_vm._v("vue.js")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://vuex.vuejs.org/"
    }
  }, [_vm._v("vuex")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://github.com/xkjyeah/vue-google-maps"
    }
  }, [_vm._v("vue2-google-maps")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://github.com/RubaXa/Sortable"
    }
  }, [_vm._v("sortablejs")]), _vm._v(" and a couple of well known approaches like centralized event bus and centralized promise bus.\n\t\t\t\tSeveral utilities like webpack, fontello, velocity and bootstrap also are in use.\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Github repo: "), _c('a', {
    attrs: {
      "href": "https://github.com/Kasheftin/route-planner-vue"
    }
  }, [_vm._v("https://github.com/Kasheftin/route-planner-vue")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1229f996"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Manager.vue
// module id = 467
// module chunks = 0